// Size select on "Passend dazu" cards in the cart drawer: keep the hidden variant id in sync.
document.addEventListener('change', (event) => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.matches('[data-rec-variant-select]')) return;
  const input = select.form?.querySelector('input[name="id"]');
  if (input) input.value = select.value;
});
